export default __webpack_public_path__ + "static/media/Product-List.be3869fd.jpg";